import React from 'react';

import classNames from 'classnames/bind';
import styles from './SectionTitle.scss';
const cx = classNames.bind(styles);

const SectionTitle = React.memo(
  ({
    title = '',
    text = '',
    color = '#333',
    fontSize = '18px',
    textAlign = '',
    letterSpacing = '0.04px',
    style = {},
    childStyle = {},
    lineHeight = '1.56',
    padding = '',
    fontWeight = '',
    disable = false,
    children,
  }) => {
    const msg = title ? title.split('\n') : [];
    const submsg = text ? text.split('\n') : [];

    // const textDeco = {
    //   textDecoration: 'line-through',
    //   textDecorationColor: 'white',
    // };

    let titleStyle = { ...style };
    // if (disable) {
    //   titleStyle = {
    //     ...titleStyle,
    //     ...textDeco,
    //   };
    // }

    return (
      <div className={cx('SectionTitle')} style={titleStyle}>
        {children ? (
          <div className={`children-box`} style={childStyle}>
            {children}
          </div>
        ) : null}
        {title ? (
          <div
            className={`title-box`}
            style={{
              padding: padding,
              textAlign: textAlign,
              fontSize: fontSize,
              color: color,
              letterSpacing: letterSpacing,
              lineHeight: lineHeight,
              fontWeight: fontWeight,
            }}
            dangerouslySetInnerHTML={{ __html: msg.join('<br/>') }}
          />
        ) : null}
        {text ? (
          <p
            dangerouslySetInnerHTML={{ __html: submsg.join('<br/>') }}
            className="copy-text"
          />
        ) : null}
      </div>
    );
  },
);

export default SectionTitle;
